import { useState } from "react";
import { planFromStart } from "@/lib/consecrationDates";

const KEY = "theotokos-consecration-plan-v1";
const readPlan = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY));
    if (!stored || !["feast", "custom"].includes(stored.mode)) return null;
    return planFromStart(stored.startDate, {
      mode: stored.mode,
      feastKey: typeof stored.feastKey === "string" ? stored.feastKey : "",
      feastName: typeof stored.feastName === "string" ? stored.feastName : "",
      year: Number.isInteger(stored.year) ? stored.year : undefined,
    });
  } catch { return null; }
};

export const useConsecrationPlan = () => {
  const [plan, setPlan] = useState(readPlan);
  const [storageError, setStorageError] = useState("");
  const savePlan = (next) => {
    setPlan(next);
    try {
      if (next) localStorage.setItem(KEY, JSON.stringify(next));
      else localStorage.removeItem(KEY);
      setStorageError("");
    } catch { setStorageError("Your dates are available for this visit, but this browser could not save the change."); }
  };
  return { plan, savePlan, storageError };
};